var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boolean-filter"},[_c('div',{staticClass:"bubble",class:_vm.state === "" ? "" : ("show-" + _vm.state),on:{"click":_vm.updateState}})])}
var staticRenderFns = []

export { render, staticRenderFns }